var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTextBottomNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 277,
    viewBox: "0 0 421 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1225_13188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.05 150.81C202.38 154.47 210.19 154.45 216.51 150.78L229.97 142.96L182.09 115.33C167.62 106.98 158.71 91.54 158.71 74.83V19.52L145.2 27.27C138.86 30.91 134.95 37.66 134.95 44.97V88.38C134.95 105.18 143.91 120.7 158.46 129.1L196.05 150.8V150.81Z",
    fill: "url(#paint0_linear_1225_13188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.68 4.94C206.1 8.39 200.51 15.45 199.1 23.93C198.88 25.28 198.76 26.66 198.76 28.06V64.96C198.76 69.21 199.9 73.29 201.96 76.84C204 80.39 206.98 83.41 210.65 85.54L222.05 92.11C227.79 95.41 234.45 97.3 241.55 97.3C252.8 97.3 262.94 92.56 270.09 84.97V106.19C270.09 110.41 268.96 114.47 266.93 118.01C264.88 121.57 261.91 124.6 258.23 126.73C250.89 130.97 241.85 130.97 234.51 126.73L210.18 112.69L192.48 102.47C181.68 96.24 175.02 84.71 175.02 72.24V23.72C175.02 19.48 176.15 15.4 178.2 11.86C180.24 8.31 183.21 5.29 186.88 3.18C194.23 -1.06 203.27 -1.06 210.6 3.18L213.67 4.95L213.68 4.94Z",
    fill: "url(#paint1_linear_1225_13188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63 27.4398C263.43 33.6698 270.09 45.1998 270.09 57.6698V57.7098C270.09 73.1198 258.03 86.0498 242.64 86.6298C239.71 86.7398 236.88 86.4098 234.2 85.6898C241.26 81.7198 246.34 74.2198 246.34 64.9498C246.34 58.6898 243.88 52.7798 239.65 48.4098C238.14 46.8398 236.4 45.4698 234.46 44.3598L209.42 29.8998V28.1398C209.42 19.9498 216.06 13.3198 224.24 13.3198C226.76 13.3198 229.13 13.9398 231.2 15.0498L252.64 27.4298L252.63 27.4398Z",
    fill: "url(#paint2_linear_1225_13188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8101 246.58V189.87H-0.399902V253.7C-0.399902 256.76 2.0801 259.24 5.1401 259.24H45.3001V246.57H12.8101V246.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.39 188.23C53.54 188.23 50.23 191.53 50.23 195.39C50.23 199.25 53.54 202.55 57.39 202.55C61.24 202.55 64.55 199.25 64.55 195.39C64.55 191.53 61.24 188.23 57.39 188.23ZM50.78 208.6V259.26H63.45V208.6H50.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28 208.59C112.54 208.59 110.97 209.61 110.27 211.2L109.22 213.55C108.01 212.56 106.8 211.57 105.37 210.8C102.84 209.48 99.31 208.05 94.91 208.05C82.24 208.05 71.23 218.95 71.23 233.93C71.23 248.91 82.24 259.81 94.91 259.81C98.99 259.81 102.29 258.6 104.6 257.39C105.92 256.62 107.13 255.85 108.12 254.86V271.34C108.12 274.4 110.6 276.88 113.66 276.88H120.78V208.6H114.28V208.59ZM96.56 247.68C89.4 247.68 83.89 242.29 83.89 233.92C83.89 225.55 89.39 220.15 96.56 220.15C103.73 220.15 109.22 225.55 109.22 233.92C109.22 242.29 103.72 247.68 96.56 247.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.12 208.59V236.67C165.12 243.28 160.82 247.68 154.66 247.68C148.5 247.68 144.2 243.28 144.2 236.67V208.59H131.53V238.32C131.53 251.53 139.9 259.8 151.9 259.8C155.97 259.8 159.6 258.48 162.14 257.05C163.57 256.28 165 255.29 166.22 254.3L167.26 256.65C167.96 258.23 169.54 259.26 171.28 259.26H177.78V208.6H165.12V208.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.36 188.23C191.51 188.23 188.2 191.53 188.2 195.39C188.2 199.25 191.5 202.55 195.36 202.55C199.22 202.55 202.52 199.25 202.52 195.39C202.52 191.53 199.22 188.23 195.36 188.23ZM188.76 208.6V259.26H201.42V208.6H188.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.11 195.42V213C245.12 212.11 243.91 211.35 242.59 210.58C240.28 209.37 236.97 208.05 232.9 208.05C220.23 208.05 209.22 218.95 209.22 233.93C209.22 248.91 220.23 259.81 232.9 259.81C237.3 259.81 240.83 258.49 243.36 257.06C244.79 256.29 246 255.3 247.21 254.31L248.25 256.65C248.96 258.24 250.53 259.26 252.27 259.26H258.77V189.89H251.65C248.59 189.89 246.11 192.37 246.11 195.43V195.42ZM234.55 247.68C227.39 247.68 221.89 242.29 221.89 233.92C221.89 225.55 227.39 220.15 234.55 220.15C241.71 220.15 247.22 225.55 247.22 233.92C247.22 242.29 241.71 247.68 234.55 247.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.35 188.23C272.5 188.23 269.19 191.53 269.19 195.39C269.19 199.25 272.49 202.55 276.35 202.55C280.21 202.55 283.51 199.25 283.51 195.39C283.51 191.53 280.21 188.23 276.35 188.23ZM269.75 208.6V259.26H282.41V208.6H269.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.42 208.59V236.67C326.42 243.28 322.13 247.68 315.96 247.68C309.79 247.68 305.5 243.28 305.5 236.67V208.59H292.84V238.32C292.84 251.53 301.21 259.8 313.21 259.8C317.29 259.8 320.92 258.48 323.45 257.05C324.88 256.28 326.31 255.29 327.52 254.3L328.56 256.65C329.27 258.23 330.84 259.26 332.58 259.26H339.08V208.6H326.41L326.42 208.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.9 208.05C398.5 208.05 394.75 209.7 392.11 211.35C390.57 212.34 389.25 213.44 388.03 214.65C387.26 213.44 386.16 212.34 384.84 211.35C382.53 209.7 378.89 208.05 373.72 208.05C370.09 208.05 367.11 209.48 365.02 210.8C363.81 211.57 362.6 212.56 361.61 213.55L360.57 211.21C359.87 209.62 358.29 208.6 356.55 208.6H350.05V259.26H362.72V230.08C362.72 223.91 366.57 220.17 370.98 220.17C375.39 220.17 379.24 223.91 379.24 230.08V259.26H391.9V230.08C391.9 223.91 395.75 220.17 400.16 220.17C404.57 220.17 408.42 223.91 408.42 230.08V259.26H421.08V228.98C421.08 215.21 413.92 208.06 402.91 208.06L402.9 208.05Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1225_13188",
    x1: 132.14,
    y1: 34.81,
    x2: 203.45,
    y2: 158.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F6B360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36C64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1225_13188",
    x1: 178.95,
    y1: 7.75,
    x2: 250.29,
    y2: 131.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F6B360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36C64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1225_13188",
    x1: 220.93,
    y1: 12.9298,
    x2: 259.9,
    y2: 80.4198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F03367"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1225_13188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421,
    height: 277,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextBottomNew);
export default __webpack_public_path__ + "static/media/logo-text-bottom-new.337fe7c01627d272219a123a398848af.svg";
export { ForwardRef as ReactComponent };